<template>
  <div>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group
        id="input-group-1"
        label="Add a journal entry:"
        label-for="input-1"
        description="This entry will be shared with all close-knit users"
      >
        <b-form-textarea
          id="input-1"
          v-model="form.journalEntry"
          placeholder="Enter text here."
          required
        ></b-form-textarea>
      </b-form-group>

      <b-form-rating
        v-model="form.rating"
        show-value
        show-value-max
        precision="2"
        icon-empty="heart"
        icon-half="heart-half"
        icon-full="heart-fill"
        icon-clear="slash-circle"
        show-clear
        variant="danger"
        stars="10"
      />
      <p class="mt-2">Rating: {{ form.rating }}</p>
      <b-button type="submit" variant="primary">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
      <b-button type="photo" variant="primary">Add Photo</b-button>
    </b-form>
    <b-card class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ form }}</pre>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        journalEntry: "",
        rating: 3.58
      },
      show: true
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.journalEntry = "";
      this.form.rating = 5.55;
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>
